import { async } from "@firebase/util";
import { getDatabase, ref, child, get, update} from "firebase/database";
import { IpAddresses } from "../Constants/constants";


///////////////////////
// Home
///////////////////////

export const get_all_events = async (uid, id) => {
    const dbRef = ref(getDatabase());
    const posts = await get(child(dbRef, `Events/${uid}/`)).then((snapshot) => {
        if (snapshot.exists()) {
          return snapshot.val();
        } else {
            console.log("No data available");
            return([])          
        }
      }).catch((error) => {        
        console.error(error);
        return([])          
      });
    return(posts)    
        
}

export const getUserData = async(uid) => {
  const dbRef = ref(getDatabase());
  const userData = await get(child(dbRef, `Users/${uid}`)).then((snapshot) => {
      if (snapshot.exists()) {    
          return snapshot.val();
      } else {
          console.log("No data available");
          // return(undefined)          
      }
    }).catch((error) => {        
      console.log(error);
      // return(undefined)          
    });    
  
  return(userData)
}

export const updateUser = async (input) => {
  const dbRef = ref(getDatabase());
  try {
    const childRef = child(dbRef, `Users/${input.uid}/`)
    const updateRes = await update(childRef,input)
    console.log("update user", updateRes)
  } catch (error) {
    console.log(error)    
  }
 
};

///////////////////////
// Notifications
///////////////////////

export const getNotifications = async(uid) => {
  const dbRef = ref(getDatabase());
  const userData = await get(child(dbRef, `notifications/${uid}`)).then((snapshot) => {
      if (snapshot.exists()) {    
          return snapshot.val();
      } else {
          console.log("No data available");
          return([])          
      }
    }).catch((error) => {        
      console.log(error);
      return([])          
    });    
  
  return(userData)
}

export const create_event = async(uid) => {
  const dbRef = ref(getDatabase());
  const userData = await get(child(dbRef, `notifications/${uid}`)).then((snapshot) => {
      if (snapshot.exists()) {    
          return snapshot.val();
      } else {
          console.log("No data available");
          return([])          
      }
    }).catch((error) => {        
      console.log(error);
      return([])          
    });    
  
  return(userData)
}

export const getRelevantUsersData = async(li) => {    
  const dbRef = ref(getDatabase());
  let users = []
  for(var i in li){
      const user = await get(child(dbRef, `Users/${li[i]}`)).then((snapshot) => {            
          if (snapshot.exists()) {           
              const snap = snapshot.val()                     
              if(snap.profilePic){
                  return({
                      profilePic: snap.profilePic,
                      uid: li[i],
                      displayName: snap.displayName,       
                      username:snap.username,
                      gender:snap.gender!==undefined?snap.gender:"male",      
                  })
              }else{
                  return({                        
                      uid: li[i],
                      displayName: snap.displayName,   
                      username:snap.username, 
                      gender:snap.gender!==undefined?snap.gender:"female",                   
                  })
              } 
          }else {
              console.log("No data available");
              return({})          
          }
        }).catch((error) => {        
          console.log(error);
          return({"error": "Something went wrong"})          
        });  
      users.push(user)
  }  
  return(users)
}

export const addPhone_details_Inuser = async (uid,number,countryCode,firstname,lastname,username,gender) => {
  const dbRef = ref(getDatabase());
  const data = {
    phoneNumber: `+${countryCode}  ${number}`,
    success: true,
  };

  try {
    const childRef = child(dbRef, `Users/${uid}`);
    let newData = {}
    if(firstname && lastname){
      newData = {
        ["phoneDetails"]: data,
        firstname,lastname,username,
        displayName:`${firstname} ${lastname}`,gender
      };
    }else{      
      newData = {
        ["phoneDetails"]: data,
        username, gender
      };
    }
    // Pushing new data to the 'Crews' node in the database
    await update(childRef, newData);
    return { success: true };
  } catch (error) {
    console.error("Error adding phone Details:", error);
    return { success: false };
  }
};

export const addPhone_details = async (uid,number,countryCode,) => {
  const dbRef = ref(getDatabase());
  const data = {
    phoneNumber: `+${countryCode}  ${number}`,
    success: true,
  };

  try {
    const childRef = child(dbRef, `Users/${uid}`);
    const newData = {
      ["phoneDetails"]: data,
     
    };
    // Pushing new data to the 'Crews' node in the database
    await update(childRef, newData);
    return { success: true };
  } catch (error) {
    console.error("Error adding phone Details:", error);
    return { success: false };
  }
};



export const getUser_phoneDetails = async (uid) => {
  const dbRef = ref(getDatabase());

  try {
    const snapshot = await get(child(dbRef, `Users/${uid}/phoneDetails`));

    if (snapshot.exists()) {
      // phoneDetails exist
      return snapshot.val();
    } else {
      // phoneDetails do not exist
      console.log("No data available");
      return false;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return false;
  }
};

export const apigetFirstname=async(uid)=>{
  const dbRef = ref(getDatabase());
 
  try {
    const snapshot = await get(child(dbRef, `Users/${uid}/firstname`));
    if (snapshot.exists()) {
      return snapshot.val();
    } else{
      return ""
    }
  } catch (error) {
    return ""
  }
}


// All followerDta

export const getFollowerData = async(uid) => {
  const dbRef = ref(getDatabase());
  const userData = await get(child(dbRef, "followers")).then((snapshot) => {
      if (snapshot.exists()) {    
          return snapshot.val();
      } else {
          console.log("No data available");
          return(undefined)          
      }
    }).catch((error) => {        
      console.log(error);
      return(undefined)          
    });    
  
  return(userData)
}

export const getFollowingData = async(uid) => {
  const dbRef = ref(getDatabase());
  const userData = await get(child(dbRef, "following")).then((snapshot) => {
      if (snapshot.exists()) {    
          return snapshot.val();
      } else {
          console.log("No data available");
          return(undefined)          
      }
    }).catch((error) => {        
      console.log(error);
      return(undefined)          
    });    
  
  return(userData)
}
